import React from 'react';
import { PageSectionsBySystemIdQuery, PageSectionFieldsFragment } from '../../@types/generated';
import Section from '@/components/Section';
import { renderSection } from './index';
import ChooseFrelsiPrice from '@/components/Frelsi/ChooseFrelsiPrice';
import { getOr } from '../utils/options';
import FrelsiCardCollection from '@/components/Frelsi/FrelsiCardCollection';
import { MobilePackageType } from '@/components/Frelsi/Types';
import FyllaFrelsi from '@/components/FyllaFrelsi';

type Props = {
  sections: Array<PageSectionsBySystemIdQuery>;
  orderedIds: Array<string>;
};

function renderFyllaFrelsi(
  pageSectionFragment: PageSectionFieldsFragment,
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>,
  setMobilePackage: React.Dispatch<React.SetStateAction<MobilePackageType | null>>,
  mobilePackage: MobilePackageType | null
) {
  if (pageSectionFragment.children?.__typename === 'InfoSet') {
    return (
      <Section
        childrenTypeName={pageSectionFragment.children?.__typename}
        sectionId={getOr(pageSectionFragment.id, '')}
        theme={getOr(pageSectionFragment.background, '')}
        marginTop={getOr(pageSectionFragment.marginTop, 32)}
        marginBottom={getOr(pageSectionFragment.marginBottom, 32)}
        gridType={getOr(pageSectionFragment.gridType as 'centered' | 'full', 'full')}
      >
        <ChooseFrelsiPrice
          setShowModal={setShowModal}
          setMobilePackage={setMobilePackage}
          mobilePackage={mobilePackage}
          infoSetId={pageSectionFragment.children.sys.id}
        />
      </Section>
    );
  }
  return null;
}

function renderCardCollection(
  pageSectionFragment: PageSectionFieldsFragment,
  setMobilePackage: React.Dispatch<React.SetStateAction<MobilePackageType | null>>,
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>
) {
  if (pageSectionFragment.children?.__typename === 'CardCollection') {
    return (
      <Section
        childrenTypeName={pageSectionFragment.children?.__typename}
        sectionId={getOr(pageSectionFragment.id, '')}
        theme={getOr(pageSectionFragment.background, '')}
        marginTop={getOr(pageSectionFragment.marginTop, 32)}
        marginBottom={getOr(pageSectionFragment.marginBottom, 32)}
        gridType={getOr(pageSectionFragment.gridType as 'centered' | 'full', 'full')}
      >
        <FrelsiCardCollection
          cardCollectionId={pageSectionFragment.children.sys.id}
          setMobilePackage={setMobilePackage}
          setShowModal={setShowModal}
        />
      </Section>
    );
  }
  return null;
}

const FrelsiFyllaPage = ({ sections, orderedIds }: Props) => {
  const [showModal, setShowModal] = React.useState(false);
  const [mobilePackage, setMobilePackage] = React.useState<MobilePackageType | null>(null);

  const pageSections = sections
    .flatMap((x) => x.pageSectionCollection?.items as PageSectionFieldsFragment[])
    .sort((a, b) => orderedIds.indexOf(a.sys.id) - orderedIds.indexOf(b.sys.id));

  return (
    <>
      <FyllaFrelsi
        showModal={showModal}
        setShowModal={setShowModal}
        mobilePackage={mobilePackage}
        setMobilePackage={setMobilePackage}
      />
      {pageSections.map((s, index) => {
        if (s.children?.__typename === 'SinglePackageHeader') {
          return renderSection(s, index === 0);
        }
        return;
      })}

      {pageSections.map((s) => renderCardCollection(s, setMobilePackage, setShowModal))}
      {pageSections.map((s) => {
        return renderFyllaFrelsi(s, setShowModal, setMobilePackage, mobilePackage);
      })}
      {pageSections.map((s, index) => {
        if (s.children?.__typename === 'FaqSection') {
          return renderSection(s, index === 0);
        }
        return;
      })}
    </>
  );
};
export default FrelsiFyllaPage;
